// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import CaretUpOutlinedSvg from "@ant-design/icons-svg/lib/asn/CaretUpOutlined";
import AntdIcon from "../components/AntdIcon";
const CaretUpOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: CaretUpOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    CaretUpOutlined.displayName = "CaretUpOutlined";
}
export default /*#__PURE__*/ React.forwardRef(CaretUpOutlined);
